@import '../../style/index';

:host {
  display: block;

  .legal-text {
    @include copy-footnotes;

    margin: 0;
  }

  .legal-text--big {
    @include copy-primary;

    color: var(--colors-grey-dark);
  }

  .legal-text--bold {
    // stylelint-disable declaration-no-important
    font-family: $font-family-semibold !important;
  }

  .legal-text--inline {
    display: inline;
  }
}
